import { render, staticRenderFns } from "./categoryActions.vue?vue&type=template&id=fef31954&"
import script from "./categoryActions.vue?vue&type=script&lang=js&"
export * from "./categoryActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports